import { createRouter, createWebHistory } from 'vue-router';
import { userAuthenticate } from "@/functions/userAuthenticate";
import { brandConfigMap } from "@/brand";
import { utagDataPost } from "@/functions/utagDataPost";

const routes = [
    {
        path: '/',
        redirect: getBaseRoute(),
    },
    {
        path: '/welcome',
        name: 'WelcomeView',
        component: () => import("@/views/WelcomeView.vue"),
    },
    {
        path: '/terms-and-conditions',
        name: 'TermsAndConditions',
        component: () => import("@/views/TermsAndConditions.vue"),
    },
    {
        path: '/subscription',
        name: 'SubscriptionView',
        component: () => import("@/views/SubscriptionView.vue"),
    },
    {
        path: '/confirm-subscription/:price/:interval',
        name: 'ConfirmSubscription',
        component: () => import("@/views/ConfirmSubscription.vue"),
    },
    {
        path: '/home',
        name: 'HomeView',
        component: () => import("@/views/HomeView.vue"),
    },
    {
        path: '/menu',
        name: 'MenuView',
        component: () => import("@/views/MenuView.vue"),
    },
    {
        path: '/settings',
        name: 'SettingsView',
        component: () => import("@/views/SettingsView.vue"),
    },
    {
        path: '/profile',
        name: 'ProfileView',
        component: () => import("@/views/MyProfile.vue"),
    },
    {
        path: '/news',
        name: 'NewsView',
        component: () => import("@/views/NewsView.vue"),
        children: [
            {
                path: 'home',
                name: 'NewsHome',
                component: () => import("@/views/news/NewsHome.vue"),
            },
            {
                path: 'articles',
                name: 'NewsArticles',
                component: () => import("@/views/news/NewsArticles.vue"),
            },
            {
                path: 'article/:articleId',
                name: 'NewsArticle',
                component: () => import("@/views/news/NewsArticle.vue"),
            },
        ]
    },
    {
        path: '/predictor',
        name: 'PredictorView',
        component: () => import("@/views/PredictorView.vue"),
        children: [
            {
                path: 'home',
                name: 'PredictorHome',
                component: () => import("@/views/predictor/PredictorHome.vue"),
            },
            {
                path: 'results',
                name: 'PredictorResults',
                component: () => import("@/views/predictor/PredictorResults.vue"),
            },
            {
                path: 'upcoming-rounds',
                name: 'PredictorUpcomingRounds',
                component: () => import("@/views/predictor/PredictorUpcomingRounds.vue"),
            },
            {
                path: 'make-predictions/:roundId',
                name: 'PredictorMakePredictions',
                component: () => import("@/views/predictor/PredictorMakePredictions.vue"),
            },
            {
                path: 'score-predictions/:roundId',
                name: 'PredictorScorePredictions',
                component: () => import("@/views/predictor/PredictorScorePredictions.vue"),
            },
            {
                path: 'my-rounds',
                name: 'PredictorMyRounds',
                component: () => import("@/views/predictor/PredictorMyRounds.vue"),
            },
            {
                path: 'leaderboard',
                name: 'PredictorLeaderboard',
                component: () => import("@/views/predictor/PredictorLeaderboard.vue"),
            },
            {
                path: 'how-to-play',
                name: 'PredictorHowToPlay',
                component: () => import("@/views/predictor/PredictorHowToPlay.vue"),
            },
        ]
    },
    // Fantasy routes - commented out for Lite Version (uncomment to re-enable)
    // {
    //     path: '/fantasy',
    //     name: 'FantasyView',
    //     component: () => import("@/views/FantasyView.vue"),
    //     children: [
    //         {
    //             path: 'home',
    //             name: 'FantasyHome',
    //             component: () => import("@/views/fantasy/FantasyHome.vue"),
    //         },
    //         {
    //             path: 'how-to-play',
    //             name: 'FantasyHowToPlay',
    //             component: () => import("@/views/fantasy/FantasyHowToPlay.vue"),
    //         },
    //         {
    //             path: 'auto-team-builder',
    //             name: 'FantasyAutoTeamBuilder',
    //             component: () => import("@/views/fantasy/FantasyAutoTeamBuilder.vue"),
    //         },
    //         {
    //             path: 'season-ranking',
    //             name: 'FantasySeasonRanking',
    //             component: () => import("@/views/fantasy/FantasySeasonRanking.vue"),
    //         },
    //         {
    //             path: 'top-picks',
    //             name: 'FantasyTopPicks',
    //             component: () => import("@/views/fantasy/FantasyTopPicks.vue"),
    //         },
    //         {
    //             path: 'upcoming-rounds',
    //             name: 'FantasyUpcomingRounds',
    //             component: () => import("@/views/fantasy/FantasyUpcomingRounds.vue"),
    //         },
    //         {
    //             path: 'team-builder',
    //             name: 'FantasyTeamBuilder',
    //             component: () => import("@/views/fantasy/FantasyTeamBuilder.vue"),
    //         },
    //         {
    //             path: 'team-selector',
    //             name: 'FantasyTeamSelector',
    //             component: () => import("@/views/fantasy/FantasyTeamSelector.vue"),
    //         },
    //         {
    //             path: 'my-rounds',
    //             name: 'FantasyMyRounds',
    //             component: () => import("@/views/fantasy/FantasyMyRounds.vue"),
    //         },
    //         {
    //             path: 'my-results',
    //             name: 'FantasyMyResults',
    //             component: () => import("@/views/fantasy/FantasyMyResults.vue"),
    //         },
    //         {
    //             path: 'round-leaderboard/:roundId',
    //             name: 'FantasyRoundLeaderboard',
    //             component: () => import("@/views/fantasy/FantasyRoundLeaderboard.vue"),
    //         },
    //     ]
    // },
    {
        path: '/trivia',
        name: 'TriviaView',
        component: () => import("@/views/TriviaView.vue"),
        children: [
            {
                path: 'home',
                name: 'TriviaHome',
                component: () => import("@/views/trivia/TriviaHome.vue"),
            },
            {
                path: 'progress',
                name: 'TriviaProgress',
                component: () => import("@/views/trivia/TriviaProgress.vue"),
            },
            {
                path: 'questions',
                name: 'TriviaQuestions',
                component: () => import("@/views/trivia/TriviaQuestions.vue"),
            },
            {
                path: 'how-to-play',
                name: 'HowToPlay',
                component: () => import("@/views/trivia/HowToPlay.vue"),
            },
            {
                path: 'prizes',
                name: 'PrizesView',
                component: () => import("@/views/trivia/PrizesView.vue"),
            },
        ]
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        window.scrollTo(0, 0);
    }
})

function getBaseRoute() {
    const domain = window.origin;
    const brandConfig = brandConfigMap.get(domain) ? brandConfigMap.get(domain) : brandConfigMap.get('default');
    return brandConfig.baseRoute;
}

router.beforeEach(async (to, from, next) => {
    await userAuthenticate(to, from, next);
})

router.afterEach((to, from, next) => utagDataPost(to, from, next));

export default router
